import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Vehicle } from './vehicle/vehicle.component'
import ImageVan from './assets/hk/van.svg'
import ImageTruck55t from './assets/hk/truck_5_5t.svg'
import ImageTruck9t from './assets/hk/truck_9t.svg'
import ImageCourier from './assets/hk/courier.svg'


const VehicleListHK = ({ estimations, quoteInProgress, numberOfVehicles }) => {
  const [t] = useTranslation()

  const courierFee = estimations.courier || t('text__body__minimum_fee__courier')
  const vanFee = estimations.van || t('text__body__minimum_fee__van')
  const mudouFee = estimations.mudou || t('text__body__minimum_fee__truck_5_5t')
  const mudou9Fee = estimations.mudou9 || t('text__body__minimum_fee__truck_9t')

  const defaultFee = Object.keys(estimations).length === 0


  return (
    <>
      <Vehicle
        image={ImageCourier}
        name={t('common__courier')}
        description={t('text__body__vehicle_description__courier')}
        extraDescription={t('text__body__vehicle_description__courier_2')}
        fee={courierFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
        numberOfVehicles={numberOfVehicles}
        feeSubText={t('text__instant_delivery__bracket')}
      />

      <Vehicle
        image={ImageVan}
        name={t('common__vehicle__van')}
        description={t('text__body__vehicle_description__van')}
        extraDescription={t('text__body__vehicle_description__van__2')}
        fee={vanFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
        numberOfVehicles={numberOfVehicles}
      />
      <Vehicle
        image={ImageTruck55t}
        name={t('common__vehicle__truck_5_5t')}
        description={t('text__body__vehicle_description__truck_5_5t')}
        extraDescription={t('text__body__vehicle_description__truck_5_5t__2')}
        fee={mudouFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
        numberOfVehicles={numberOfVehicles}
      />
      <Vehicle
        image={ImageTruck9t}
        name={t('common__vehicle__truck_9t')}
        description={t('text__body__vehicle_description__truck_9t')}
        extraDescription={t('text__body__vehicle_description__truck_9t__2')}
        fee={mudou9Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
        numberOfVehicles={numberOfVehicles}
      />
    </>
  )
}

VehicleListHK.propTypes = {
  estimations: PropTypes.object,
  quoteInProgress: PropTypes.bool,
  numberOfVehicles: PropTypes.number
}

export { VehicleListHK }
